import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'isMail'
})

export class IsMailPipe implements PipeTransform{

    transform(value: string, args?: number): any{

        let output: string = '';

        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)){
            output = '<a href="mailto:' + value + '">' + value + '</a>'
        } else {
            output = '<span>' + value + '</span>'
        }

        return output;

    }

}



// WEBPACK FOOTER //
// ./src/shared/email.pipe.ts